let _ = require('../_.js');
let $ = jQuery;

let auctioncast_button_is_showing = false;

// General code for initializing and setting up hooks for the code below
_.auctionui_gallery_module_init = async function () {

    // _.AuctionCast_AuctionCast.on_auctioncast_started(handle_auctioncast_started);
    _.AuctionCast_AuctionCast.on_auctioncast_ui_operation(handle_auctioncast_ui_operation);

    _.on_ui_update_always(null, _.ac_gallery_handle_button_sizing);
    _.on_ui_resize(_.ac_gallery_handle_button_sizing);

    _.on_ui_update_always(null, _._refresh_gallery_height_for_ac);
    _.on_ui_resize(_._refresh_gallery_height_for_ac);

    // console.warn(_.ac_state.property);

    // If it is a property, load the gallery
    if (_.ac_state.property) {
        // Must be awaited to postpone starting auctioncast video until gallery loaded
        await _.gallery_init_listing(_.ac_state.property.id);
    }
    console.log("Gallery init complete");
}

// Auctioncast UI operations
// This concerns itself with the positioning of the player.
// Another module will handle the PIP player, this is only for gallery.
// The auctioncast module itself will handle the video player element.

let auctioncast_player_is_in_gallery = false;

let update_auctioncast_ui_for_mobile = function () {
    if (auctioncast_player_is_in_gallery) {
        if (window.innerWidth < 800) {
            console.log("Send should mute");
            _.AuctionCast_AuctionCast.send_message_player_frame('overlay_should_mute');
            _.AuctionCast_AuctionCast.send_message_player_frame('overlay_show');
        } else {
            _.AuctionCast_AuctionCast.send_message_player_frame('overlay_should_not_mute');
            _.AuctionCast_AuctionCast.send_message_player_frame('overlay_hide');
        }
    }
}

window.addEventListener('resize', update_auctioncast_ui_for_mobile);

var handle_auctioncast_ui_operation = function (operation) {

    // This will emit while is_this_auction == false, because there is no stream so the stream
    // doesn't belong to any auction.  Maybe that logic needs cleaning up, idk.
    if (operation == _.AuctionCast_AuctionCast.OPERATION_HIDE_THIS_AUCTION_AUCTIONCAST_UI ||
        operation == _.AuctionCast_AuctionCast.OPERATION_REMOVE_MAIN_PLAYER) {
        $(".ac-stream-show-button").hide();
        auctioncast_button_is_showing = false;
        _.ac_gallery_handle_button_sizing();
        if (current_gallery_show_type == 'auctioncast') {
            _.ac_show_gallery_type('images');
        }
        return;
    }

    // Prevent further operations from happening from other auctions
    if (!_.AuctionCast_AuctionCast.is_this_auction) {
        return;
    }

    switch (operation) {

        case _.AuctionCast_AuctionCast.OPERATION_DISPLAY_LIVE:
        case _.AuctionCast_AuctionCast.OPERATION_DISPLAY_OVERLAY:
            _.ac_show_gallery_type('auctioncast');
            break;

        case _.AuctionCast_AuctionCast.OPERATION_SHOW_MAIN_PLAYER:
        case _.AuctionCast_AuctionCast.OPERATION_TRANSITION_PIP_TO_MAIN_PLAYER:
            _.AuctionCast_AuctionCast.set_player_target_element($(".ac-gallery-auctioncast-container"));
            auctioncast_player_is_in_gallery = true;
            update_auctioncast_ui_for_mobile();
            break;

        // Move to PIP player
        case _.AuctionCast_AuctionCast.OPERATION_SHOW_PIP_PLAYER:
        case _.AuctionCast_AuctionCast.OPERATION_TRANSITION_MAIN_TO_PIP_PLAYER:
            auctioncast_player_is_in_gallery = false;
            break;

        case _.AuctionCast_AuctionCast.OPERATION_SHOW_THIS_AUCTION_AUCTIONCAST_UI:
            $(".ac-stream-show-button").show();
            auctioncast_button_is_showing = true;
            _.ac_gallery_handle_button_sizing();
            break;

        case _.AuctionCast_AuctionCast.OPERATION_SELECT_MAIN_PLAYER_SHOW:
            _.ac_show_gallery_type('auctioncast');
            break;

    }

    _._refresh_gallery_height_for_ac();
}

// // Auctioncast started (standby mode counts as started).  Switch UI to show auctioncast player.
// var handle_auctioncast_started = function (status) {
// }

// var handle_auctioncast_stopped = function (status) {
// }

// var handle_auctioncast_experience_stopped = function (status) {
// }

// var handle_auctioncast_status = function (status) {
// }

// Function to load gallery for an auction item
// _.gallery_init_auction = async function (auction_item) {

//     $(".ac-gallery-galleria-container").children().hide();

//     let $component = $(".ac-gallery-galleria-container").component(auction_item.id);

//     $component.show();

//     let photos = await auction_item.photos.fetch();
//     let videos = null;

//     if (auction_item.video_url && auction_item.video_thumbnail) {
//         videos = [{ 'url': auction_item.video_url, 'thumbnail': auction_item.video_thumbnail }];
//     }

//     if (!$component.data('galleria')) {
//         $component.galleria_init(photos, videos);
//     }
// }

// Load gallery, uses images from property.
_.gallery_init_listing = async function (property_id) {
    $(".ac-gallery-galleria-container").children().hide();

    let $component = $(".ac-gallery-galleria-container").component(property_id);

    $component.show();

    let property = await App_Models_Property.get(property_id);

    let photos = await property.photos.fetch();
    let videos = null;

    if (property.video) {
        _.ac_state.current_video = property.video;
        $(".ac-btn-action-view-video").show();
    } else {
        $(".ac-btn-action-view-video").hide();
    }

    if (property.video && property.video_thumbnail) {
        videos = [{ 'url': property.video, 'thumbnail': property.video_thumbnail }];
    }

    // Hide / show terms of service button
    let $view_terms_button = $(".ac-btn-action-view-terms");

    if (property.terms_and_conditions_id) {
        if ((await property.terms_and_conditions.fetch()).terms) {
            $view_terms_button.show();
        } else {
            $view_terms_button.hide();
        }
    } else {
        $view_terms_button.hide();
    }

    if (!$component.data('galleria')) {
        await $component.galleria_init(photos, videos);
    }

    // No geocode (latitude / longitude NULL): no map, no directions link
    let has_location = !!(property.latitude && property.longitude);
    $('.component-green-button[data-show="map"]').toggle(has_location);
    $(".ac-gallery-maplink").toggle(has_location);

    if (has_location) {
        await _.property_map_init(property);

        $(".ac-gallery-maplink").attr('href', "https://www.google.com/maps/dir/?api=1&destination=" + encodeURIComponent(property.latitude + ", " + property.longitude));
    }
}


// Adds jquery method galleria_init() which initializes target with a set of videos.

let galleria_reload_timer = null;
let track_position_handler = null;
let last_position_of_galleria = null; // todo: fix me: if gallery starts loading then we move the element before it finishes it breaks.
// this is a bandaid that assumes that the first position after galleria is loaded is wrong
// and we reload it.

let gallery_has_loaded_once = false;

// Todo: Reinitialize if changing between mobile and desktop views
$.fn.galleria_init = async function (photos = null, videos = null) {

    _.AuctionUI._hide_main_preloader();

    let $this = this;
    let $galleria = this;

    // Set photos and videos if provided
    if (photos) {
        $this.data('gallery-photos', photos);
    }

    if (videos) {
        $this.data('gallery-videos', videos);
    }

    let _destroy = function () {
        if ($this.data('galleria-loaded')) {
            if ($this.data('galleria')) {
                $this.data('galleria').destroy();
            }
            $this.data('galleria-loaded', false);
        }
    }

    let _is_visible = function () {
        return $this.is(":visible") && $.contains(document, $this[0]);
    }

    // Resizes the gallery if possible, otherwise reloads.
    let _reload = _.debounce(100, function () {
        if (!_is_visible()) {
            clearInterval(track_position_handler);
            _destroy();
            $this.addClass('galleria-wants-reload', true);
        } else if ($this.data('galleria')) {
            $this.data('galleria').resize();
            let r1, r2, r3;
            let resizer = function () {
                try {
                    $this.data('galleria').resize();
                } catch (e) {
                    console.log("Error resizing gallery, reloading")
                    clearTimeout(r1);
                    clearTimeout(r2);
                    clearTimeout(r3);
                    _destroy();
                    setTimeout(function () {
                        $this.galleria_init();
                    }, 200);
                }
            };
            r1 = setTimeout(resizer, 500);
            r2 = setTimeout(resizer, 1000);
            r3 = setTimeout(resizer, 2000);
        } else {
            clearInterval(track_position_handler);
            _destroy();
            setTimeout(function () {
                $this.galleria_init();
            }, 200);
        }
    });

    // Flag to track whether we've crossed a image quality threshold
    let _window_size_threshold = function () {
        let window_size_threshold = 0;
        // if (window.innerWidth > 1300) {
        // window_size_threshold = 1;
        // }
        if (window.innerWidth > 1500) {
            window_size_threshold = 2;
        }
        return window_size_threshold;
    }

    let old_threshold = _window_size_threshold();
    let lastMaxHeight = null;

    // Hack to reload the gallery when switching between 'big' and 'small' sized controls.
    if (!$this.data('galleria-resize-hooks')) {
        $this.data('galleria-resize-hooks', true);
        $this.removeClass('galleria-wants-reload', false);

        // Reload when visible if reload requested
        setInterval(function () {
            // Suicide when no longer visible
            if (!$this.is(":visible")) {
                // _reload checks to see if active, destroys, and enqueues a reload when
                // made visible again, which is all the behaviors we want
                if (!document.fullscreenElement || !document.fullscreenElement.classList.contains('galleria-container')) {
                    // last_position_of_galleria = null;
                    // $(".ac-gallery-galleria-container").addClass('ac-gallery-galleria-container-preload');
                    clearTimeout(galleria_reload_timer);
                    _reload();
                }
            }

            // Reload when requested
            if ($this.hasClass('galleria-wants-reload') && $this.is(":visible")) {
                $this.removeClass('galleria-wants-reload', false);
                $this.galleria_init();
            }
        }, 200);
    }

    // Initializes a galleria component on target.  Destroys the existing one if it already exists.

    // If gallery already loaded, destroy it
    _destroy();

    // Clear dom
    $this.empty();

    // Postpone loading if not visible
    if (!_is_visible()) {
        _reload();
        return;
    }

    $this.addClass("galleria-init");

    // We need to unload any other gallerias that are not visible before loading the new one.
    // Idk why, this library is trash at dealing with hide events.
    $(".galleria-init").each(function () {
        let $_that = $(this);
        if (!$_that.is(":visible") && $_that.data('galleria-loaded') && !$_that.is($this)) {
            $_that.data('galleria').destroy();
            $_that.data('galleria-loaded', false);
            $_that.addClass('galleria-wants-reload', true);
        }
    });

    // Load media.  We load photos resized appropriate for target device.
    let targetImageWidth = _window_size_threshold() == 0 ? 800 : 1800;

    // Define photos
    if ($this.data('gallery-photos')) {
        $this.data('gallery-photos').sort(function (a, b) {
            return a.order - b.order;
        }).forEach(function (photo) {
            $this.append($("<img />")
                .attr('src', _.photo_to_url(photo, targetImageWidth))
                //                .attr('src', _.photo_to_url(photo, 200))
                //                .attr('data-big', _.photo_to_url(photo, targetImageWidth))
            );
        });
    }

    // Define videos
    // Define videos
    // if ($this.data('gallery-videos')) {
    //     $this.data('gallery-videos').forEach(function (video) {
    //         let $a = $("<a data-type='video'></a>").attr('href', video.url);
    //         let $img = $("<img />").attr('src', video.thumbnail);
    //         $a.append($img);
    //         $this.append($a);
    //     });
    // }

    $this.data('galleria-loaded', true);

    // Save current pos for reload check
    await _.sleep(250);
    _._store_galleria_current_pos_as_valid();
    $this.removeClass('galleria-wants-reload', false);

    // Setup a promise to resolve when galleria loaded

    let resolve_promise = false;

    // Activate the gallery
    let galleria_promise = new Promise(function (resolve) {
        Galleria.run($this[0], {
            theme: "azur",
            lightbox: true,
            clicknext: false,
            trueFullscreen: true,
            imageCrop: false,
        }).ready(function () {

            if (!gallery_has_loaded_once) {
                if (!_.__start_listening_for_updates_did_start) {
                    console.log("Gallery has loaded");
                } else {
                    console.warn("Gallery was loaded AFTER start_listening_for_updates, this is a race condition error");
                }
                gallery_has_loaded_once = true;
                setTimeout(function () {
                    resolve();
                }, 250);
            }

            if ($this.data('galleria')) {
                $this.data('galleria').play();
            }

            // Hacks to move around elements if we are using 'big' controls
            if (_window_size_threshold() == 2) {
                $this.find(".galleria-play")
                    .empty()
                    .append($('<i class="large-icon-galleria large-icon-galleria-play">')
                        .addClass('fa-solid fa-play').css('font-size', '40px'))
                    .append($('<i class="large-icon-galleria large-icon-galleria-pause">')
                        .addClass('fa-solid fa-pause').css('font-size', '40px'))
                    .css({
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        transform: 'translateY(-3px)'
                    });
                $this.find(".galleria-fullscreen")
                    .empty()
                    .append($('<i class="large-icon-galleria">')
                        .addClass('fa-solid fa-expand').css('font-size', '40px'))
                    .css({
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        transform: 'translateY(-3px)'
                    });
            }

            // Galleria is a resource hog.  Restart it every 30 minutes.
            clearTimeout(galleria_reload_timer);
            galleria_reload_timer = setTimeout(function () {
                _reload();
            }, 1000 * 60 * 30)

            let galleria_fullscreen_exception = false;
            function galleria_pos_check_changed() {
                if (document.fullscreenElement) {
                    // Do not try to reload when fullscreen
                    galleria_fullscreen_exception = true;
                    return;
                }

                if (galleria_fullscreen_exception) {
                    galleria_fullscreen_exception = false;
                    setTimeout(function () {
                        _reload();
                    }, 250);
                    return;
                }

                let $ele = $(".ac-gallery-galleria-container");
                let currentOffset = $ele.offset();  // Get the current offset relative to the document

                let currentSize = {
                    width: $ele.outerWidth(),
                    height: $ele.outerHeight()
                };

                // Check if the offset or size has changed
                if (!last_position_of_galleria || (
                    // Math.abs(last_position_of_galleria.top - currentOffset.top) > 4 ||
                    Math.abs(last_position_of_galleria.left - currentOffset.left) > 2 ||
                    Math.abs(last_position_of_galleria.width - currentSize.width) > 2 ||
                    Math.abs(last_position_of_galleria.height - currentSize.height) > 2
                )) {
                    _._store_galleria_current_pos_as_valid();

                    setTimeout(function () {
                        _reload();
                    }, 100);
                }
            }

            // Track position on screen, reload if it changes.
            // We set last_position_of_galleria to null to force at least one reload after first load.
            track_position_handler = setInterval(galleria_pos_check_changed, 500);

            // This line is hit after the first load.
            if (last_position_of_galleria !== null) {
                $(".ac-gallery-galleria-container").removeClass('ac-gallery-galleria-container-preload');
            }
        });
    });

    // Do not resolve this async function until the gallery has loaded at least once
    if (!gallery_has_loaded_once) {
        await galleria_promise;
    }

    console.log("Gallery has resolved");
};

_._store_galleria_current_pos_as_valid = function () {
    let $ele = $(".ac-gallery-galleria-container");
    let currentOffset = $ele.offset();  // Get the current offset relative to the document

    let currentSize = {
        width: $ele.outerWidth(),
        height: $ele.outerHeight()
    };

    // Update last_position_of_galleria with current values
    // *** see notes on last_position_of_galleria at its definition
    last_position_of_galleria = {
        top: currentOffset.top,
        left: currentOffset.left,
        width: currentSize.width,
        height: currentSize.height
    };
}


// This could be done better
let mapSingle;
let center;

_.property_map_init = function (property) {
    var mapElement;

    try {

        center = new google.maps.LatLng(property.latitude, property.longitude);

        var mapOptionsSingle = {
            center: center,
            zoom: 16,
            zoomControl: true,
            mapTypeControl: true,
            scaleControl: false,
            draggable: true,
            streetViewControl: false,
            mapTypeId: google.maps.MapTypeId.SATELLITE,
        };

        mapElement = $(".ac-gallery-map")[0];

        mapSingle = new google.maps.Map(mapElement, mapOptionsSingle);
        let coords = property.draw_coordinates;

        if (coords) {
            // Sometimes a doubly encoded json string?? wtf?
            if (typeof (coords) == "string") {
                coords = JSON.parse(coords);
            }
            if (typeof (coords) == "string") {
                coords = JSON.parse(coords);
            }
            if (coords.length) {
                // Loop through each shape
                for (var i = coords.length - 1; i >= 0; i--) {
                    var shape = new google.maps.Polygon({
                        paths: coords[i],
                        strokeColor: "#00FF00",
                        strokeOpacity: 0.8,
                        strokeWeight: 3,
                        fillColor: "#00FF00",
                        fillOpacity: 0.08,
                    });

                    shape.setMap(mapSingle);
                }
            }
        }

        var markers = [];

        var markericon = {
            url: "/wp-content/themes/landproz/img/just-bean.svg",
            anchor: new google.maps.Point(25, 25),
            size: new google.maps.Size(50, 50),
        };

        var marker = new google.maps.Marker({
            icon: markericon,
            position: center,
            map: mapSingle,
        });

        markers.push(marker);

    } catch (e) {
        console.error(e);
    }
}

let current_gallery_show_type = null;

_.ac_get_show_gallery_type = function () {
    return current_gallery_show_type;
}

// Function for switching which gallery media is shown
_.ac_show_gallery_type = async function (show_type) {

    if (current_gallery_show_type === show_type) {
        return;
    }

    current_gallery_show_type = show_type;

    $(".ac-gallery-controls-button-selected").removeClass("ac-gallery-controls-button-selected");

    $(".ac-gallery-auctioncast-container").hide();
    $(".ac-gallery-galleria-container").hide();
    $(".ac-gallery-map").hide();
    $(".ac-gallery-description").hide();
    $(".ac-gallery-terms").hide();
    $(".ac-gallery-video").empty().hide();
    $(".ac-gallery-hide").show();

    $(".ac-gallery-controls").find(".component-green-button").each(function () {
        if ($(this).attr('data-show') == show_type) {
            $(this).addClass("ac-gallery-controls-button-selected");
        }
    });

    // $("#ac-gallery-auctioncast-container").hide();

    if (show_type != 'video') {
        // $(".ac-gallery-video").hide().video_js_dispose();
    }

    if (show_type == "map") {

        $(".ac-gallery-map").show();

        google.maps.event.trigger(mapSingle, "resize");
        mapSingle.setCenter(center);

    } else if (show_type == "auctioncast") {

        $(".ac-gallery-auctioncast-container").show();

    } else if (show_type == "activity") {

        $(".ac-gallery-activity").show();

    } else if (show_type == "info") {

        $(".ac-gallery-description").html(_.AuctionUI.get_current_item().description).show();

    } else if (show_type == 'terms') {

        $(".ac-gallery-terms").show();

        let property = await _.ac_state.auction.property.fetch();
        let toc = await property.terms_and_conditions.fetch();
        console.log(toc);
        $(".ac-gallery-terms-content").html(toc.terms);
        $(".ac-gallery-terms-lastupdated").text(new _.TimeManager(toc.created_at_central).human_date());

    } else if (show_type == "images") {
        $(".ac-gallery-galleria-container").show();

    } else if (show_type == 'video') {
        // Hard prevent video if cachearmer
        if (_.is_cachewarmer()) {
            return false;
        }

        // Only supports vimeo right now.  Lets support mp4 and youtube later.
        // $(".ac-gallery-video").show().video_js(_.ac_state.current_video);
        // console.log(_.ac_state.current_video);
        if (_.ac_state.current_video) {
            let url = _.ac_state.current_video;
            if (url.indexOf('vimeo.com/') == -1) {
                return;
            }
            let id = url.split('vimeo.com/')[1];

            // <iframe src="https://player.vimeo.com/video/{video_id}" width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>

            let $iframe = $('<iframe width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen/>').attr('src', 'https://player.vimeo.com/video/' + id);
            $(".ac-gallery-video").show().empty().append($iframe);
        }

        // Mute the auctioncast stream if any.
        _.AuctionCast_AuctionCast.mute();
    }

    _.AuctionCast_AuctionCast.stream_status_refresh();

    _.ui_update();
}

// Keep the gallery sized 16:9 + toolbar height of gallery (if it was visible) for consistency.
_._refresh_gallery_height_for_ac = function () {
    let $gallery = $('.ac-gallery-media-container');
    let galleria_toolbar_height_if_it_was_visible = window.matchMedia("(min-width: 1500px)").matches ? 80 : 40;
    let new_height = $gallery[0].offsetWidth / 16 * 9 + galleria_toolbar_height_if_it_was_visible;

    // capping it at 725px.
    if (new_height > 725) {
        new_height = 725;
    }

    $gallery.styleInt('max-height', new_height);
    $gallery.styleInt('height', new_height);
}


// Handler for user controls
_.on_ui_update_once(".ac-gallery-controls", function () {
    $(this).find("button").on("click", function () {
        let type = $(this).data("show");
        if (type) {
            _.ac_show_gallery_type(type);
        }
    });
});


// When called, determines what styles to apply to gallery buttons based on button count and browser size.
let last_row_map = null;
let last_content_width = null;
let last_count_visible = null;
let text_width_test_canvas = null;
let second_run = false;
_.ac_gallery_handle_button_sizing = function () {
    _.ui_prevent_update_loop(function () {
        if (!$(".ac-gallery-controls").is(":visible")) {
            return;
        }

        if (auctioncast_button_is_showing) {
            $(".ac-stream-show-button").show();
        } else {
            $(".ac-stream-show-button").hide();
        }

        let breakpoints = [{
            'content_width': 0,
            'min_width': 140,
            'font_size': 13,
            'height': 30,
        }, {
            //     'content_width': 0,
            //     'min_width': 210,
            //     'font_size': 17,
            //     'height': 50,
            // }, {
            'content_width': 600,
            'min_width': 150,
            'font_size': 18,
            'height': 50,
        }, {
            'content_width': 700,
            'min_width': 160,
            'font_size': 19,
            'height': 55,
        }, {
            'content_width': 800,
            'min_width': 190,
            'font_size': 20,
            'height': 60,
        }, {
            'content_width': 900,
            'min_width': 190,
            'font_size': 20,
            'height': 60,
        }]

        // For current browser width, make buttons evenly spaced.  If they can't fit within their
        // min width, split them into multiple rows, with all rows being even except for last which
        // has remainder.

        let content_width = $(".ac-gallery-controls").outerWidth();
        let button_count = $(".ac-gallery-controls .component-green-button:visible").length;

        let bp = null;

        for (let i in breakpoints) {
            if (bp === null || breakpoints[i].content_width < content_width) {
                bp = breakpoints[i];
            }
        }

        // Each row should have the maximum number of buttons possible, with the topmost rows having the most buttons.

        function distributeButtons(content_width, button_count, bp_min_width) {
            try {
                // At least one per row: a hidden / zero-width container would divide by 0 below
                let buttons_per_row = Math.max(1, Math.floor(content_width / bp_min_width));
                let number_rows = parseInt(Math.ceil(button_count / buttons_per_row));
                let buttons_distribution = new Array(number_rows).fill(0);

                for (let i = 0; i < button_count; i++) {
                    buttons_distribution[i % number_rows]++;
                }

                return buttons_distribution.sort((a, b) => a - b);
            } catch (e) {
                console.log("Temporary error resizing gallery: ", e);
            }
        }

        try {

            // row_map is an array of the number of button elements that should go in a row.
            let row_map = distributeButtons(content_width, button_count, bp.min_width);

            // console.log(content_width);
            // console.log(button_count);
            // console.log(bp.min_width);
            // console.log(row_map);

            let $buttons = $(".ac-gallery-controls .component-green-button");

            // Mark which ones are visible and which ones are not.
            $buttons.each(function () {
                $(this).data('wasvisible', $(this).is(":visible"));
            });

            // Should we update position?
            if (JSON.stringify([row_map, bp]) != last_row_map) {
                last_row_map = JSON.stringify([row_map, bp]);

                console.log("Reordering buttons below gallery with map", row_map);

                // Detach all the buttons, put them off dom.
                let $buttons_collected = $("<div />").append($buttons); // using oAppend because append will cause an infinite loop by triggering ui_update again

                let $parent = $(".ac-gallery-controls");
                $parent.empty();

                let button_index = 0;
                for (let i = 0; i < row_map.length; i++) {
                    let $div = $("<div />");
                    for (let j = 0; j < row_map[i] && button_index < $buttons.length; j++) {
                        $div.append($buttons.eq(button_index));
                        if (!$buttons.eq(button_index).data("wasvisible")) {
                            j--;
                        }
                        button_index++;
                    }
                    // Put missing hidden ones on the end of the last row
                    if (row_map.length == i + 1) {
                        $buttons_collected.children().each(function () {
                            $div.append($(this));
                        });
                    }
                    $parent.append($div);
                }
            }

            // Should we update font?  Font should be reduced so the text fits in the button.
            if (last_content_width != content_width || last_count_visible != button_count) {

                last_content_width = content_width * 1;
                last_count_visible = button_count * 1;

                let font_size = bp.font_size * 1;
                let text_overflowed = false;
                if (!text_width_test_canvas) {
                    text_width_test_canvas = document.createElement("canvas").getContext("2d");
                }
                do {
                    text_overflowed = false;
                    $buttons.each(function () {
                        let $button = $(this);

                        if (!$button.is(":visible")) {
                            return;
                        }

                        let button = $button.get(0);
                        let computed = $button.getComputedStyle();
                        text_width_test_canvas.font = computed['font-weight'] + " " + font_size + "px " + computed['font-family'];
                        let text_width = text_width_test_canvas.measureText(" " + $button.text().toUpperCase().trim()).width;
                        let icon_width = $button.find("i").outerWidth();
                        let extra_padding = 10;
                        let total_text_width = text_width + icon_width + extra_padding;
                        let available_width = (button.offsetWidth -
                            parseInt($button.css('padding-left').replace('px', '')) -
                            parseInt($button.css('padding-right').replace('px', ''))
                        );
                        // console.log("TW", total_text_width);
                        // console.log("OW", available_width);
                        // console.log("IW", icon_width);
                        if (total_text_width > available_width) {
                            text_overflowed = true;
                            console.warn("Overflow", font_size, $button.text().trim());
                        }
                    })
                    if (text_overflowed && font_size > 8) {
                        font_size--;
                    }
                } while (text_overflowed && font_size > 8);
                $buttons.css('font-size', font_size + "px");
            }
        } catch (e) {
            console.log("Temporary error resizing gallery: ", e);
        }

        if (!second_run) {
            second_run = true;
            setTimeout(_.ac_gallery_handle_button_sizing, 100);
        } else {
            second_run = false;
        }

    });

}
